import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@messaia/cdk';
import { Order } from '../../models/order';
import { OrderService } from '../../services/order.service';

@Component({
    selector: 'app-additional-number-blocks-dialog',
    templateUrl: 'additional-number-blocks-dialog.component.html'
})
export class AdditionalNumberBlocksDialogComponent extends BaseComponent {

    /**
     * count: number
     */
    public count: number;

    /**
     * Constructor
     * @param dialogRef 
     * @param data 
     */
    constructor(
        protected service: OrderService,
        public dialogRef: MatDialogRef<AdditionalNumberBlocksDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Order,
        protected route: ActivatedRoute,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        super(route, changeDetectorRef)
    }

    /**
     * Save data
     */
    public save(): void {
        this.service.addPhoneNumberblocks(this.data.id, this.count)
            .subscribe({
                next: x => this.dialogRef.close(),
                error: (error) => this.parseErrors(error)
            });
    }

    /**
     * Closes the dialog
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}